export default "__VITE_ASSET__kMh2X0nO__"